import React from "react";
import { ConfigSection } from "config/adminConfig";

interface SectionNavProps {
  sections: ConfigSection[];
  activeKey: string;
  onChange: (key: string) => void;
}

const SectionNav: React.FC<SectionNavProps> = ({ sections, activeKey, onChange }) => {
  return (
    <aside className="w-44 shrink-0 pt-1">
      <p className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-3 px-3">
        Sections
      </p>
      <nav className="space-y-1">
        {sections.map((s) => (
          <button
            key={s.key}
            onClick={() => onChange(s.key)}
            className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              activeKey === s.key
                ? "bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400"
                : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
            }`}
          >
            {s.label}
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default SectionNav;
